import { render, staticRenderFns } from "./InfoContainer.vue?vue&type=template&id=75f8171b&scoped=true&"
import script from "./InfoContainer.vue?vue&type=script&lang=js&"
export * from "./InfoContainer.vue?vue&type=script&lang=js&"
import style0 from "./InfoContainer.vue?vue&type=style&index=0&id=75f8171b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f8171b",
  null
  
)

/* custom blocks */
import block0 from "./InfoContainer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports